import React from "react";
import { Skeleton } from "@mui/material";

function SidePostItem(props) {
  const { isLoading } = props;
  return (
    <div className="w-full h-auto flex items-start py-4 border-b border-gray-400">
      <div className="w-24 h-24 overflow-hidden shrink-0">
        {isLoading ? (
          <Skeleton variant="rounded" width={96} height={96} />
        ) : (
          <img
            alt=""
            className="object-cover"
            src="https://images-platform.99static.com//NP04ST37d8iQ4vyukLy4CsYDA8M=/293x114:1272x1093/fit-in/590x590/99designs-contests-attachments/93/93732/attachment_93732060"
          />
        )}
      </div>
      <div className="flex-grow pl-4">
        {isLoading ? (
          <>
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="w-3/2"  />
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="w-1/2" />
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="w-3/4"  />
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="w-1/4"  />
          </>
        ) : (
          <p className="line-clamp-4 text-base ">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum.
          </p>
        )}
      </div>
    </div>
  );
}

export default SidePostItem;
